import { mapGeometry } from "./mapGeometry";
import { processSegments } from "../../segment/processSegments";
import { PortalLineSegment } from "../../segment/types";
import { Feature } from "../../../core/geo/types";

export const mapFeature = async (geoJsonFeature: Feature, envParams: string) => {
    geoJsonFeature.geometry = mapGeometry(geoJsonFeature);
    geoJsonFeature.properties.segments = await processSegments(
        geoJsonFeature.properties.segments as unknown as PortalLineSegment[],
        envParams
    );
    return geoJsonFeature;
};
